/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportListUploadStatusesByPlatformQueryResponse, SocialExportListUploadStatusesByPlatformPathParams, SocialExportListUploadStatusesByPlatform400, SocialExportListUploadStatusesByPlatform401, SocialExportListUploadStatusesByPlatform403 } from "../models/SocialExportListUploadStatusesByPlatform";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { socialExportListUploadStatusesByPlatform } from "../axios/socialExportListUploadStatusesByPlatform";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const socialExportListUploadStatusesByPlatformQueryKey = (platform: SocialExportListUploadStatusesByPlatformPathParams["platform"]) => ["api-v2", { url: '/social-export/v1/upload/status/all/:platform', params: {platform:platform} }] as const

export type SocialExportListUploadStatusesByPlatformQueryKey = ReturnType<typeof socialExportListUploadStatusesByPlatformQueryKey>

export function socialExportListUploadStatusesByPlatformQueryOptions(platform: SocialExportListUploadStatusesByPlatformPathParams["platform"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = socialExportListUploadStatusesByPlatformQueryKey(platform)
        return queryOptions<SocialExportListUploadStatusesByPlatformQueryResponse, ResponseErrorConfig<SocialExportListUploadStatusesByPlatform400 | SocialExportListUploadStatusesByPlatform401 | SocialExportListUploadStatusesByPlatform403>, SocialExportListUploadStatusesByPlatformQueryResponse, typeof queryKey>({
         enabled: !!(platform),
         queryKey,
         queryFn: async ({ signal }) => {
            return socialExportListUploadStatusesByPlatform(platform, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns all uploads for the authenticated client on the given platform.
 * @summary List upload statuses for a platform
 * {@link /social-export/v1/upload/status/all/:platform}
 */
export function useSocialExportListUploadStatusesByPlatform<TData = SocialExportListUploadStatusesByPlatformQueryResponse, TQueryData = SocialExportListUploadStatusesByPlatformQueryResponse, TQueryKey extends QueryKey = SocialExportListUploadStatusesByPlatformQueryKey>(platform: SocialExportListUploadStatusesByPlatformPathParams["platform"], options: 
{
  query?: Partial<QueryObserverOptions<SocialExportListUploadStatusesByPlatformQueryResponse, ResponseErrorConfig<SocialExportListUploadStatusesByPlatform400 | SocialExportListUploadStatusesByPlatform401 | SocialExportListUploadStatusesByPlatform403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? socialExportListUploadStatusesByPlatformQueryKey(platform)
         

         const query = useQuery({
          ...socialExportListUploadStatusesByPlatformQueryOptions(platform, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SocialExportListUploadStatusesByPlatform400 | SocialExportListUploadStatusesByPlatform401 | SocialExportListUploadStatusesByPlatform403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}